module.exports = __webpack_public_path__ + "38bcafdf9cff98a4f0cb2160c94e90b5.pdf";